<template>
  <div class="page-content" style="margin-top: 20px">
    <el-row class="search-title common-table-top">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">编辑产品</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="form-submit-page">
        <el-form :inline="false" :model="formInline" ref="formInline" :rules="rules"  class="box-content-form" label-width="100px">
          <el-form-item label="商品类型:" prop="">
            <el-select ref="input" v-model="formInline.pro_type" placeholder="请选择">
              <el-option
                v-for="item in productType"
                :key="item.productId"
                :label="item.name"
                :value="item.productId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品编码:" prop="pro_code" v-if="formInline.pro_type === 1">
            <el-input v-model="formInline.pro_code" placeholder="请输入商品编码"></el-input>
          </el-form-item>
          <el-form-item label="优惠券链接:" prop="quan_url" v-if="formInline.pro_type === 2">
            <el-input v-model="formInline.quan_url" placeholder="请输入优惠券链接"></el-input>
          </el-form-item>
          <el-form-item label="商品名称:">
            <el-input v-model="formInline.name" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item label="所需积分:">
            <el-input v-model="formInline.integral" placeholder="请输入积分"></el-input>
          </el-form-item>
          <el-form-item label="所需金额:">
            <el-input v-model="formInline.price" placeholder="请输入金额"></el-input>
          </el-form-item>
          <el-form-item label="排序:">
            <el-input v-model="formInline.sort" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="兑换范围:">
            <el-select v-model="memberValue" multiple placeholder="请选择" class="interest-type">
              <el-option
                v-for="item in memberOptions"
                :key="item.id"
                :label="item.level_title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="库存:">
            <el-input v-model="formInline.stock" placeholder="请输入库存"></el-input>
          </el-form-item>
          <el-form-item label="主展示图:">
            <el-upload
              class="avatar-uploader"
              name="file_upload"
              :action="uploadURL"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <div v-if="formInline.pic_url" class="upload_img">
                <img v-if="formInline.pic_url" :src="formInline.pic_url" class="avatar">
                <div class="modify_img">点击修改</div>
              </div>
              <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
              <img v-else src="../../assets/images/Group.png" class="default-acivity">
              <div slot="tip" style="line-height:20px;color:#606266;">必填！建议尺寸340*340</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="图文详情:" class="picture-text-item">
            <el-upload class="pic-uploader" action="" style="display: none;" :show-file-list="false"></el-upload>
            <!--上面这个el-upload没有作用只是为了撑起form-->
            <editor ref="editMessages" v-model="formInline.description" class="picture-text-details" :action="uploadURL"></editor>
          </el-form-item>
          <el-form-item>
            <div style="display: flex; justify-content: flex-start; flex-direction: row; margin-bottom: 20px;">
              <el-button class="save-btn second-page-btn" type="primary" @click="saveProductAction">保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>
<script>
import { API_HOST } from '@/api/local'
import { modifyProduct, getProductDetails, getMemberLevelList } from '@/api/customer.js'
import editor from '@/components/common/editor'

export default {
  name: 'editProduct',
  data () {
    return {
      productType: [
        {
          name: '实物',
          productId: 1
        },
        {
          name: '优惠券',
          productId: 2
        }
      ],
      formInline: {
        gradeList: []
      },
      typesOptions: [
        {
          value: 1,
          label: '实物'
        },
        {
          value: 2,
          label: '优惠券'
        }
      ],
      memberOptions: [],
      memberValue: [],
      rules: {
        pro_type: [
          { required: true, message: '请选择商品类型', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' }
        ],
        integral: [
          { required: true, message: '请输入所需积分', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入所需金额', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
        stock: [
          { required: true, message: '请输入库存', trigger: 'blur' }
        ],
        pic_url: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        grade_list: [
          // { required: true, message: '请输入兑换范围', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    uploadURL() {
      return API_HOST + 'admin/Upload/upload'
    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      _g.toastMsg('success', '上传成功')
      this.formInline.pic_url = res.data.path
    },
    beforeAvatarUpload(file) {
      _g.toastMsg('success', '正在上传')
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M)
    },
    saveProductAction() {
      let id = this.$route.query.id
      this.formInline.grade_list = this.memberValue.toString()
      if (this.formInline.grade_list === '') {
        _g.toastMsg('error', '请选择兑换范围')
      }
      let reg = new RegExp('(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&amp;%@!\\-\\/]))?')
      if (!reg.test(this.formInline.quan_url) && this.formInline.pro_type === 2) {
        _g.toastMsg('error', '请以http://或者https://开头输入网址')
        return
      }
      modifyProduct(id, this.formInline).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/product-list')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    getData() {
      let id = this.$route.query.id
      getProductDetails(id).then((res) => {
        this.formInline = res.data.data
        this.formInline.price = this.formInline.price / 100
        if (this.formInline.grade_list !== '') {
          for (let one of this.formInline.grade_list.split(',')) {
            this.memberValue.push(parseInt(one))
          }
        }
        this.$nextTick(() => {
          this.$refs.input.$el.querySelector('input').focus()
        })
      })
    },
    getMemberList() {
      getMemberLevelList().then(res => {
        this.memberOptions = res.data.data.list
      })
    }
  },
  mounted () {
  },
  created() {
    this.getData()
    this.getMemberList()
  },
  components: {
    editor
  }
}
</script>

<style scoped>
.upload_img{
  position: relative;
}
.upload_img:hover .modify_img{
  display: inline-block;
}
.modify_img{
  position: absolute;
  height: 100%;
  width: 100%;
  background: #000;
  opacity: 0.6;
  display: none;
  top: 0;
  left: 0;
  color: #fff;
  font-size: 18px;
  line-height: 178px;
}
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.add-btn{
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content-div {
  width: 520px;
  margin: 0 auto;
}
.box-content-form {
  width: 530px!important;
  margin: 30px auto;
  text-align: center;
}
.box-content-form .el-form-item {
  width: 520px;
}
.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.save-btn {
  /*margin-right: 170px;*/
  align-items: center;
}
.picture-text-details {
  margin-bottom: 100px;
  width: 600px;
  height: 300px;
}
</style>
